import axios from 'axios';
import { toast, Bounce } from 'react-toastify';

export const httpInvoke = (config, data, params = '') => {
    return new Promise((resolve, reject) => {
        axios({
            headers: { Authorization: 'Bearer ' + localStorage.getItem('lawgeekToken') || '',
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json',

             },
            
            method: config.method,
            params: params,
            url: 'https://lawgeek.associates/appserver' + config.endPoint,
            // url: 'http://localhost:4000' + config.endPoint,
            data: data
        }).then((result) => {
            if (result.data.status) {
                if (config.isAlert) {
                    toast.success(result.data.response.msg, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                        transition: Bounce,
                    });
                }
            }
            resolve(result.data);
        }).catch((error) => {

            let msg = error.response.data.error.msg || 'Something Went Wrong please try again.'
            toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
                transition: Bounce,
            });
            if (error.response.status == '401') {
                setTimeout(() => {
                    localStorage.clear();
                    window.location.reload();
                }, 3000);
            }
            reject(error);

        });
    })
}